import { PolicyComponentCreationModeTypes } from "@enums/policy-component-creation-mode-types";
import { SelectOption } from "@iddataweb/idw-common-ui/types";

export const POLICY_COMPONENT_CREATION_TYPE_OPTIONS: Array<SelectOption> = [
    {
        label: "Create components from scratch ",
        value: PolicyComponentCreationModeTypes.FROM_SCRATCH
    },
    {
        label: "Create from an existing component ",
        value: PolicyComponentCreationModeTypes.FROM_COPY_COMPONENT
    }
]